import { useEffect, useState } from "react";
import { getProfile, manageJobs } from "../../services/auth";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Pagination from "rc-pagination";
const JobListingsTable = () => {
  const routing = useNavigate();
  const [jobData, setJobData] = useState([]);
  const [user, setUserData] = useState([]);
  const [status, setStatus] = useState("");

  const [query, setQuery] = useState("");

  const [Limit, setLimit] = useState(null);
  const [current, setCurrent] = useState(1);
  // Get the correct offset
  const offset = (current - 1) * 15;
  const editBtn = (id) => {
    routing(`/post-jobs?jobId=${id}`);
  };
  const viewPost = async (id) => {
    routing(`/job-view?ViewId=${id}`);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await manageJobs(1);
        setJobData(data?.data);
        setLimit(data?.pageData?.totalPosts);
      } catch (error) {}
    };

    fetchData();
  }, []);

  const fetchCurrentData = async (Current) => {
    const resData = await manageJobs(Current);
    setJobData(resData?.data);
  };
  const handleChangePagecount = async (e) => {
    setCurrent(e);
    const Current = e;
    await fetchCurrentData(Current);
  };

  const filterData = (e) => {
    const value = e.target.value.toLowerCase();
    setQuery(value);

    const filterData = jobData?.filter((item, index) => {
      return item?.title?.toLowerCase().includes(value);
    });
  };

  // Date formatting function
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear(); // Adding 4 years to the original date
    return `${month} ${day},${year}`;
  };

  // const expiryDate = "2025-02-20"; // Example date
  // if (checkExpiry(expiryDate)) {
  // } else {
  // }

  const fetchApplicant = async () => {
    try {
      const data = await getProfile();
      setUserData(data?.data);
      if (data?.data?.updateStatus) setStatus(data?.data?.updateStatus);
    } catch (error) {}
  };

  useEffect(() => {
    fetchApplicant();
  }, []);

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <button>
          {/* <img src={arrowright} alt="no image" className="arrows" /> */}
          Pre
        </button>
      );
    }
    if (type === "next") {
      return (
        <button>
          {/* <img src={arrowleft} alt="no image" className="arrows" /> */}
          Next
        </button>
      );
    }
    return originalElement;
  };

  return (
    <div className="tabs-box">
      <div className="d-flex justify-content-between align-items-center">
        <div className="widget-title">
          <h4>My Job Listings</h4>
        </div>
        <div>
          {/* <div className="d-flex align-items-center">
            <input
              type="text"
              className="form-control"
              placeholder="Search title..."
              value={query}
              onChange={(e) => {
                filterData(e);
              }}
              style={{
                border: "2px solid orange",
                borderRadius: "25px",
                padding: "10px 25px",
                width: "250px",
                outline: "none",
              }}
            />
            <button
              className="btn"
              style={{
                marginLeft: "-50px",
                background: "transparent",
                border: "none",
              }}
            >
              🔍
           </button>
          </div> */}
        </div>
      </div>

      {status == "Approved" ? (
        <>
          <div className="widget-content">
            <div className="table-outer">
              <table className="default-table manage-job-table">
                <thead>
                  <tr>
                    <th className="text-centers">ID</th>
                    <th className="text-centers">Title</th>
                    <th className="text-centers">No of Openings</th>
                    <th className="text-centers">Created</th>
                    <th className="text-centers">Expired</th>
                    <th className="text-centers">Status</th>
                    <th className="text-centers">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {jobData?.length > 0 &&
                    jobData.map((item, index) => (
                      <tr>
                        <td>{offset + index + 1}.</td>
                        <td>
                          <div className="job-block">
                            <div className="inner-box">
                              <div
                                className="contentss"
                                style={{ border: "none !important" }}
                              >
                                {/* <span className="company-logo  rounded">
                              <img
                                width={70}
                                height={70}
                                src={
                                  item?.companyId &&
                                  item?.companyId?.profileDetail?.companyLogo
                                }
                                alt="logo"
                              />
                            </span> */}
                                <div className="">
                                  {item.title.charAt(0).toUpperCase()}
                                  {item?.title.slice(1)}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    paddingTop: "10px",
                                  }}
                                >
                                  <span className="icon flaticon-briefcase"></span>
                                  {item?.employmentType.replace("_", " ")}
                                  <span className="icon flaticon-map-locator ms-3"></span>
                                  {item?.contactDetails?.city}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="text-center">{item?.openings}</td>
                        <td>{formatDate(item?.createdAt)}</td>
                        <td>{formatDate(item?.deadlineDate)}</td>
                        <td
                          className="status cursor"
                          onClick={() => editBtn(item?._id)}
                        >
                          {/* {moment().isAfter(
                        moment(item?.deadlineDate, "YYYY-MM-DD")
                      )
                        ? "Expired"
                        : "Active"} */}

                          {item?.status.charAt(0).toUpperCase()}
                          {item?.status.slice(1)}
                          {/* {item?.status.charAt(0).toUpperCase()}
                      {item?.status?.slice(1, 100)} */}
                        </td>
                        <td>
                          <div className="option-box d-flex gap-2">
                            <button
                              className="d-flex justify-content-center box-icons"
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                background: "#97144d",
                                color: "white",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "20px",
                                outline: "none",
                                border: "none",
                              }}
                              onClick={() => viewPost(item?._id)}
                            >
                              <i class="fa-solid fa-eye"></i>
                            </button>

                            <button
                              data-text="Edit Applications"
                              onClick={() => editBtn(item?._id)}
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                background: "#97144d",
                                color: "white",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "20px",
                                outline: "none",
                                border: "none",
                              }}
                            >
                              <span className="la la-pencil"></span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {Limit > 15 ? (
                <>
                  <div>
                    <Pagination
                      className="pagination-data mt-4"
                      // total={Math.round((Limit * 10) / 100)}
                      total={Limit}
                      onChange={handleChangePagecount}
                      // current={Current}
                      itemRender={PrevNextArrow}
                      breakLabel="..."
                      pageSize={15}
                    />
                  </div>
                </>
              ) : (
                <></>
              )}

              {jobData?.length == 0 && (
                <div className="fw-bold mt-4 text-center mb-4 w-100">
                  No Job's found..!
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          {Object.values(user?.contactDetails || {})?.some(
            (item, index) => item?.length > 0
          ) ||
          Object.values(user?.profileDetail || {})?.every(
            (item, index) => item?.length > 0
          ) ? (
            <>
              {status == "Pending" && (
                <>
                  <div
                    className="mt-2 text-center fw-bold fs-4 mb-5"
                    style={{ paddingBottom: "20px" }}
                  >
                    Waiting for admin approval on your profile.
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <div
                className="mt-5 text-center fw-bold fs-4 mb-5 d-flex align-items-center justify-content-center gap-3"
                style={{ paddingBottom: "20px" }}
              >
                <span style={{ color: "#96144d" }}>
                  <i class="fa-solid fa-user"></i>
                </span>{" "}
                Please complete your profile
              </div>
            </>
          )}
        </>
      )}
      {/* Start table widget content */}

      {/* End table widget content */}
    </div>
  );
};

export default JobListingsTable;
